module.exports = __webpack_public_path__ + "img/hemline_sweep.e8a569e3.png";